import {Box, Typography} from '@mui/material'

import {dataTestId} from '../../../common/utils'

export const VerticalNavigationHeader = ({selectedDate}: {selectedDate: string}) => {
  return (
    <Box sx={{pb: 2, pt: 3, pl: 3}} {...dataTestId('vertical-navigation-tree-header')}>
      <Typography variant="h4">{selectedDate}</Typography>
    </Box>
  )
}
